import React from "react";
import Firebase from "../services/firebase";
import plansList from "../components/plans/plansList";
const ACTIONS = {
	SET_HAVE_DATA: "set-have-data",
	SET_HAVE_SEGMENTS: "set-have-segments",
	SET_USER: "set-user",
	SET_LOADING: "set-loading",
	SET_SPINNER: "set-spinner",
	SET_SEG_MAP: "set-seg-map",
	SET_HITS_MAP: "set-hits-map",
	SET_AUD_MAP: "set-aud-map",
	SET_FIREBASE_INITIALIZED: "set-firebase-initialized",
	SET_CUSTOMER: "set-customer",
	SET_PLANS: "set-plans",
	SET_SEGMENTS: "set-segments",
	SET_CODE: "set-selected-code",
	SET_WEBSITE: "set-websiteURL",
	SET_STATE: "set-state",
	RELOAD_DATA: "reload-data"
};

const StateContext = React.createContext({
	haveData: false,
	haveSegments: false,
	user: Firebase.getUser(),
	customer: null,
	segments: null,
	plans: null,
	loading: true,
	selectedSegmentCode: null,
	showSpinner: false,
	firebaseInitialized: false,
	actions: ACTIONS,
	plansList,
	segMap: null,
	hitsMap: null,
	audMap: null,
	websiteURL: "",
	firebase: Firebase,
	reloadData: false
});

export default StateContext;
